<template>
  <el-form ref="ff" v-loading="loading" label-width="80px" :model="formdata">
    <el-row :gutter="10">
      <el-col :span="12">
        <el-form-item label="任务状态">
          <el-radio-group size="small" v-model="formdata.State">
            <el-radio-button :label="9">即时完成</el-radio-button>
            <el-radio-button :label="0">工作计划</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="工作类别" prop="Type">
          <metaPicker type="schedule-type" :value.sync="formdata.Type" />
        </el-form-item>
      </el-col>
      <template v-if="formdata.State == 0">
        <el-col :span="12">
          <el-form-item label="人员安排" prop="Operator">
            <staffPicker
              :value.sync="formdata.UserName"
              @selectHandler="pickStaff"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="任务时间" prop="PlanTime" required>
            <el-date-picker
              type="datetime"
              v-model="formdata.PlanTime"
              value-format="yyyy-MM-dd HH:mm"
              placeholder="请选择"
              :picker-options="{
                disabledDate: (time) => {
                  return time < new Date();
                },
              }"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </template>
    </el-row>

    <el-form-item label="客户单位" prop="Client">
      <clientPicker
        v-model="formdata.Client"
        allow-create
        default-first-option
        clearable
        style="width: 100%"
        @change="pickCustomer"
      />
    </el-form-item>
    <el-form-item label="联系地址" prop="Address">
      <el-input v-model="formdata.Address" clearable />
    </el-form-item>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="联系人" prop="Linkman">
          <el-input v-model="formdata.Linkman" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系电话" prop="Linktel">
          <el-input v-model="formdata.Linktel" clearable />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="任务内容" prop="Request">
      <el-input v-model="formdata.Request" />
    </el-form-item>
    <el-form-item label="处理结果" prop="Result" v-if="formdata.State == 9">
      <el-input v-model="formdata.Result" />
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        @click="onSubmit"
        v-loading.fullscreen.lock="loading"
      >
        提交
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import staffPicker from "@/views/company/branch/staff/_input.vue";
export default {
  components: {
    metaPicker: () => import("@/views/system/meta/item/_picker.vue"),
    clientPicker: () => import("@/views/company/customer/_picker.vue"),
    staffPicker,
  },
  data() {
    return {
      loading: false,
      formdata: {
        State: 9,
        Type: "01",
      },
    };
  },
  props: {
    source: { type: Object },
    layerid: { type: String },
  },
  methods: {
    //选择人员
    pickStaff(res) {
      this.formdata.Operator = res.Id;
      this.formdata.UserName = res.Name;
    },
    //选择客户
    pickCustomer(res) {
      this.$set(this.formdata, "CustomerId", res.Id);
      this.$set(this.formdata, "Client", res.Name);
      this.$set(this.formdata, "Address", res.Address);
      this.$set(this.formdata, "Linkman", res.Linkman);
      this.$set(this.formdata, "Linktel", res.Linktel);
    },
    //提交数据
    onSubmit() {
      this.$refs["ff"].validate((valid) => {
        if (valid && !this.loading) {
          this.loading = true;
          this.$apis.job.schedule
            .create(this.formdata)
            .then(() => {
              this.$message({ message: "数据提交成功！", type: "success" });
              this.$layer.close(this.layerid);
              this.$parent.loadData();
            })
            .catch((e) => {
              this.$message.error(e || "执行错误");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>
